<template>
  <div class="call-us-icons">
    <a href="https://wa.me/966920013370" target="_blank" class="whatsapp">
      <img src="/assets/images/icons/whatsapp-icon.png" alt="واتساب دراية" />
      <p class="hover-number">920013370</p>
    </a>
    <a href="tel:your-phone-number" class="phone">
      <img src="/assets/images/icons/phone.png" alt="رقم دراية" />
      <p class="hover-number">920013370</p>
    </a>
  </div>

  <!-- header-section -->
  <section id="header">
    <header class="desktop-header">
      <nav class="navbar navbar-expand-lg">
        <div class="container">
          <!-- Logo -->
          <router-link
            class="navbar-brand"
            to="/"
            data-aos="fade-up"
            data-aos-delay="50"
            data-aos-duration="500"
          >
            <img src="/assets/images/logos/logo.png" alt="derayah Logo" />
            <span class="d-none">Derayah Recruitment</span>
          </router-link>
          <!-- Navigation Links -->
          <div class="collapse navbar-collapse">
            <ul class="navbar-nav mb-2 mx-auto mb-lg-0">
              <li class="nav-item" data-aos="fade-up" data-aos-delay="50">
                <router-link class="nav-link" to="/about">من نحن</router-link>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link"
                  aria-disabled="false"
                  data-aos="fade-up"
                  data-aos-delay="50"
                  >خدماتنا <i class="fa fa-chevron-down me-2"></i
                ></a>
                <ul class="dropdown-menu">
                  <li>
                    <router-link to="/workers">السير الذاتية</router-link>
                  </li>
                  <li><router-link to="/career">طلب الاستقدام</router-link></li>
                </ul>
              </li>
              <li class="nav-item" data-aos="fade-up" data-aos-delay="250">
                <router-link class="nav-link" to="/countries"
                  >دول الاستقدام</router-link
                >
              </li>
              <li class="nav-item" data-aos="fade-up" data-aos-delay="250">
                <router-link class="nav-link" to="/faq"
                  >الاسئله الشائعه</router-link
                >
              </li>
              <li class="nav-item" data-aos="fade-up" data-aos-delay="250">
                <router-link class="nav-link" to="/workers"
                  >عرض العماله</router-link
                >
              </li>
              <li class="nav-item" data-aos="fade-up" data-aos-delay="350">
                <router-link class="nav-link" to="/contact"
                  >اتصل بنا</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>

    <!-- Mobile Header -->
    <header class="mobile-header transparent-header">
      <router-link to="/"
        ><img src="/assets/images/logos/white-logo.png" alt="Logo" class="logo"
      /></router-link>
      <i
        class="fas fa-bars hamburger-icon"
        onclick="toggleMenu()"
        id="openIcon"
      ></i>
      <i
        class="fas fa-times hamburger-icon"
        onclick="toggleMenu()"
        id="closeIcon"
        style="display: none"
      ></i>
    </header>

    <!-- Side Menu -->
    <nav class="side-menu" id="sideMenu">
      <ul>
        <li><router-link to="/about">من نحن</router-link></li>
        <li class="dropdown-mobile">
          <a href="#" class="dropdown-toggle">خدماتنا</a>
          <ul class="dropdown-menu-mobile">
            <li>
              <router-link to="/workers">السير الذاتية</router-link>
            </li>
            <li><router-link to="/career">طلب الاستقدام</router-link></li>
          </ul>
        </li>
        <li>
          <router-link to="/countries">دول الاستقدام</router-link>
        </li>
        <li>
          <router-link to="/faq">الاسئله الشائعه</router-link>
        </li>
        <li>
          <router-link to="/workers">عرض العماله</router-link>
        </li>
        <li><router-link to="/contact">اتصل بنا</router-link></li>
      </ul>
    </nav>

    <!-- Overlay -->
    <div class="overlay" id="overlay" onclick="toggleMenu()"></div>
  </section>
</template>
